import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { ITimeSlotsParams } from '@campfire-nx/api';

import { AppointmentService } from '@open-portal-app/appointments/services/appointment.service';

import { COMMON_CONSTANTS } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class AppointmentResolver implements Resolve<any> {
  constructor(
    private router: Router,
    private appointmentService: AppointmentService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    const navigation = this.router.getCurrentNavigation();

    if (
      navigation &&
      navigation.extras &&
      navigation.extras.state
    ) {
      const { topic, option, entity, entity_ref, raptorSource } = navigation.extras.state;
      const timeslotParams: ITimeSlotsParams = {
        country: COMMON_CONSTANTS.appointmentsDefaultCountry,
        topic,
        option,
        ...(entity ? { entity } : {}),
        ...(entity_ref ? { entity_ref } : {})
      };

      this.appointmentService.details = { ...timeslotParams, raptorSource };

      return this.appointmentService.getTimeslots(timeslotParams);
    } else {
      // redirect the user to Support Flow when there's no appointment details
      this.router.navigate(['/support']);

      return false;
    }
  }
}
